import React from 'react';
import { withRouter } from 'react-router';
import { RouteComponentProps } from 'react-router';
import { withTranslation, WithTranslation } from "react-i18next";

import { Button } from '@germix/germix-react-core';

interface Props extends RouteComponentProps<any>, WithTranslation
{
}
interface State
{
}

/**
 * @author Germán Martínez
 */
class NotFound extends React.Component<Props, State>
{
    render()
    {
        return (
<div className="not-found">
    <img src="/assets/404.png"/>
    <p>{ this.props.t('notfound.message') }</p>
    <Button color="primary" onClick={() =>
    {
        this.props.history.replace('/');
    }}>{ this.props.t('notfound.button') }</Button>
</div>
        );
    }
};
export default withRouter(withTranslation('common')(NotFound));
